import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { withRouter } from 'react-router-dom';
import Bind from 'lodash-decorators/bind';

import messages from './NewsArticleView.intl';

import styles from './NewsArticleView.module.scss';

import NewsStore from 'stores/News.store';
import Location from 'stores/Location.store';
import LanguageService from 'services/Language.service';

import FeaturedNews from './components/FeaturedNews/FeaturedNews';
import NewsArticle from './components/NewsArticle/NewsArticle';
import { ANCHOR } from 'common/consts/common';
import { Container, Title } from 'common/components/Layout/Layout';

import Placeholder from 'common/components/Placeholder/Placeholder';
import ArticleBig from 'common/components/Placeholder/components/ArticleBig/ArticleBig';
import ArticleSmall from 'common/components/Placeholder/components/ArticleSmall/ArticleSmall';

@injectIntl
@withRouter
class NewsArticleView extends Component {
  state = {
    newsArticle: null
  };

  currentLanguage = LanguageService.getLang();

  async UNSAFE_componentWillReceiveProps(nextProps, prevState) {
    if (this.props.match.params.slug !== nextProps.match.params.slug) {
      await this.getArticle(nextProps.match.params.slug);
    }
  }

  async componentDidMount() {
    await this.getArticle(this.props.match.params.slug);
  }
  // temporarily unused
  // async getArticle(id) {
  //   const newsArticle = await NewsStore.getNewsById(id);
  //   LanguageService.adjustSlugToLanguage(this, newsArticle);
  //
  //   this.setState({ newsArticle });
  // }

  async getArticle(slug) {
    const availableLanguages = LanguageService.getSortedLanguages();

    let newsArticle = await availableLanguages.reduce(
      (previousPromise, nextLang) => {
        return previousPromise.then(
          result => result || NewsStore.getNewsBySlug(slug, nextLang)
        );
      },
      Promise.resolve()
    );

    if (newsArticle) {
      if (LanguageService.getLang() !== newsArticle.system.language) {
        newsArticle = await NewsStore.getNewsById(newsArticle.id);
      }
    }
    LanguageService.adjustSlugToLanguage(this, newsArticle);

    this.setState({ newsArticle });
  }

  didComeFromListing() {
    const lastPath = Location.getLastLocation();
    return lastPath && lastPath.pathname === ANCHOR.NEWS[this.currentLanguage];
  }

  @Bind
  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { newsArticle } = this.state;

    return (
      <div className={styles.NewsArticleView}>
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Container>
          <div className={`${styles.ContainerArticle} `}>
            <div className={styles.ReturnDiv}>
              <i className={styles.ArrowLeft} />
              {this.didComeFromListing() ? (
                <span className={styles.Return} onClick={this.goBack}>
                  {this.props.intl.formatMessage(messages.return)}
                </span>
              ) : (
                <Link
                  to={ANCHOR.NEWS[this.currentLanguage]}
                  className={styles.Return}
                >
                  {this.props.intl.formatMessage(messages.return)}
                </Link>
              )}
            </div>
            <Placeholder component={<ArticleBig />} ready={!!newsArticle}>
              {newsArticle && <NewsArticle news={newsArticle} />}
            </Placeholder>
          </div>
          <Placeholder
            component={<ArticleSmall className={styles.ArticleSmall} />}
            ready={!!newsArticle}
          >
            {newsArticle && (
              <FeaturedNews activeNewsID={newsArticle.system.id} />
            )}
          </Placeholder>
        </Container>
      </div>
    );
  }
}

export default NewsArticleView;



// WEBPACK FOOTER //
// ./src/views/News/NewsArticleView.js